import ConcernCategoriesContainer from './ConcernCategoriesContainer';

export default ConcernCategoriesContainer;
